import Image from "next/image";
import { useRouter } from "next/router";

interface CompanyNameLogoProps {
  name?: string;
  logo?: string;
  slug?: string;
  org_type?: string;
  linked?: boolean;
}

export default function CompanyNameLogo({
  name,
  logo,
  slug,
  org_type,
  linked = true,
}: CompanyNameLogoProps) {
  const router = useRouter();

  // Prevents hydration error
  const handleClick = () => {
    const targetPath =
      org_type === "school" ? "/school/" + slug : "/company/" + slug;
    {
      linked ? router.push(targetPath) : null;
    }
  };

  return (
    <>
      {name ? (
        <>
          <div
            onClick={handleClick}
            className={`flex cursor-pointer items-center ${
              linked ? "hover:scale-[1.025]" : null
            }`}
            suppressHydrationWarning
          >
            <Image
              className="thumbnail-sm my-1 mr-3"
              src={logo}
              alt={name + " Logo"}
              width={64}
              height={64}
            />

            <div
              className={`mr-2 mt-[1px] text-sm font-bold text-gray-700 dark:text-white`}
            >
              {name}
            </div>
          </div>
        </>
      ) : (
        <div className="flex items-center">
          <div className="mr-2 h-7 w-7 bg-gray-200" />

          <div className="mr-3 text-sm font-bold dark:text-white">
            <div className="text-gray-300">
              {org_type === "school" ? "School Name" : "Company Name"}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
